import script from "./message-audio-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-audio-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-audio-web.vue?vue&type=style&index=0&id=1e3b34f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3b34f2"]])

export default __exports__